export const findTreeItemParentIds = ({ id, treeData }) => {
  const collectParentIds = (currentId, acc) => {
    const { parentId } = treeData[currentId] || {};

    if (!parentId) {
      return acc;
    }

    return collectParentIds(parentId, [...acc, parentId]);
  };

  return collectParentIds(id, []);
};
